import { userService } from '../services';
import config from '../config/config';

export const LogoutAction = {
    userLogout,
    
};

async function userLogout(data) {
    try {
  
        // let apiEndpoint = `${config.baseUrl}${config.apiName.logout}`
        let response = await userService.logoutService(data);
       return 
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}